import { allImagesNew } from '../../images/nintendoShopItemImages';
import { ninShop } from '../../images';



export const shopItemImageSelector = (shop, region, denomination) => {
   return allImagesNew.find(item => item.includes(`${shop}-${region?.toLowerCase()}-${denomination}.`)) || allImagesNew.find(item => item.includes(`${shop}-default.`))
};